import React from 'react'
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack'
import { AuthContainer } from 'containers'
import { ConfirmAlert, Container, PrimaryButton, BackButton, QueryStatusAlert } from 'components'
// @ts-ignore
import TNC_PDF from './sdh_tnc.pdf'
import { useAcceptTnC } from 'pages/shared/TermsAndConditions/hooks'

export const TermsAndConditions: React.FC = () => {
  const { onTnCAcceptance, logOut, user, acceptedTnC } = AuthContainer.useContainer()

  const pdfInputRef = React.useRef<HTMLDivElement>(null)
  const [showAlert, setShowAlert] = React.useState(false)
  const [pdfStatus, setPdfStatus] = React.useState<'loading' | 'success' | 'error'>('loading')
  const [tncRead, setTncRead] = React.useState(false)

  const { getAcceptTnCStatus, getAcceptTnCError, mutateAcceptTnC } = useAcceptTnC()

  /* istanbul ignore next */
  React.useEffect(() => {
    const ref = pdfInputRef?.current

    const updateScrollPosition = (e: any) => {
      const obj = e.currentTarget
      if (obj.scrollTop >= obj.scrollHeight - obj.offsetHeight - 350) setTncRead(true)
    }

    if (ref) {
      ref.addEventListener('scroll', updateScrollPosition, false)

      return () => {
        ref.removeEventListener('scroll', updateScrollPosition, false)
      }
    }
  }, [])

  return (
    <main data-testid="terms-and-conditions" className="flex items-center justify-center">
      <Container>
        <QueryStatusAlert
          queryStatus={pdfStatus}
          errorTitle="Failed to load Terms and Conditions:"
          errorMsg="Please try again!"
        />
        <QueryStatusAlert
          queryStatus={getAcceptTnCStatus}
          errorTitle="Could not accept Terms and Conditions:"
          errorObj={getAcceptTnCError}
          show404Error
        />

        {acceptedTnC === true && (
          <div className="pt-12">
            <BackButton buttonText="Supplier Reports" routeTo="/home" />
          </div>
        )}
        <section className="flex flex-col text-center items-center justify-center mt-5">
          <div data-testid={`tnc-title-container`}>
            <h1 className="text-2xl font-semibold">SOFTWARE LICENCE AGREEMENT</h1>
            <h1 className="text-2xl font-semibold">RELATING TO MORRISONS SUPPLIER DATA HUB</h1>
          </div>
          <div
            data-testid="tnc-text-container"
            className="flex justify-center w-full max-h-screen-xs mt-5 p-5 bg-gray-100"
          >
            <Document
              inputRef={pdfInputRef}
              className={'overflow-auto'}
              file={TNC_PDF}
              loading={'Loading TnC...'}
              onLoadSuccess={() => setPdfStatus('success')}
              onLoadError={() => setPdfStatus('error')}
            >
              {Array.from(Array(9).keys()).map((item) => (
                <Page
                  key={`page-${item}`}
                  pageNumber={item + 1}
                  scale={1.5}
                  loading={''}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                />
              ))}
            </Document>
          </div>
        </section>

        {acceptedTnC === true && (
          <section className="flex justify-center my-5 text-xl font-semibold">
            You have accepted "SOFTWARE LICENCE AGREEMENT RELATING TO MORRISONS SUPPLIER DATA HUB".
          </section>
        )}

        {acceptedTnC === false && (
          <section className="flex flex-col items-center mt-2 mb-10">
            <span className="text-lg font-semibold">(Please read the document to be able to accept it)</span>
            <div className="flex gap-5">
              <PrimaryButton
                buttonText="Accept"
                disabled={pdfStatus !== 'success' || tncRead === false}
                onClick={() => {
                  mutateAcceptTnC(user?.googleId ?? '', {
                    onSuccess: () => {
                      onTnCAcceptance()
                    },
                  })
                }}
              />
              <PrimaryButton
                outlined
                buttonText="Decline"
                onClick={() => {
                  setShowAlert(true)
                }}
              />
            </div>
          </section>
        )}
      </Container>
      <ConfirmAlert
        title="PLease note"
        message="You will be logged out of the Supplier Data Hub due to disagreement to the Terms and Conditions. Do you want to proceed?"
        open={showAlert}
        onClose={() => setShowAlert(false)}
        onConfirm={() => {
          setShowAlert(false)
          logOut()
        }}
      />
    </main>
  )
}

export default TermsAndConditions
